export default __webpack_public_path__ + "static/media/linkedin-footer.f6c96c3b.svg";